import { api } from ".."

// funcao para pesquisar usuários
const UsersService = async (name: string, page: number) => {
    
    const response = await api.get('users', {
        params: {
            name, page
        }
    });

    return response;

}
// funcao para pesquisar usuários

// funcao para cadastrar usuários
const CreateUserService = async (name: string, username: string, email: string, password: string, roles: string) => {
    
    const response = await api.post('users', {
        name, email, username, password, roles
    });

    return response;

}
// funcao para cadastrar usuários

// funcao para pesquisar roles
const RolesService = async () => {

    const response = await api.get("/users/roles");

    return response;

}
// funcao para pesquisar roles

// funcao para pesquisar aprovadores
const ApproversService = async () => {

    const response = await api.get('users/approvers');

    return response;

}
// funcao para pesquisar aprovadores

// função para pesquisar dados do usuário
const UserShowService = async (id: number) => {

    const response = await api.get(`users/${id}`);

    return response;

}
// função para pesquisar dados do usuário

// função para editar usuário
const UserUpdateService = async (id: number, name: string, username: string, email: string, roles: string) => {

    const response = await api.put(`users/${id}`, {
        name, username, email, roles
    });

    return response;

}
// função para editar usuário

// função para alterar a senha de um usuário
const UserChangePasswordService = async (id: number, password: string) => {

    const response = await api.put(`users/password/${id}`, {
        password
    });

    return response;

}
// função para alterar a senha de um usuário

// função para ativar desativar usuário
const UserDeleteService = async (id: number) => {

    const response = await api.delete(`users/${id}`);

    return response;

}
// função para ativar desativar usuário

// função para pesquisar usuários que são gerentes
const UsersManagersService = async (name: string, page: number) => {

    const response = await api.get('users/managers', {
        params: {
            name, page
        }
    });

    return response;

}
// função para pesquisar usuários que são gerentes

// função para pesquisar dados do gerente
const UsersManagersShowService = async (id: number, page: number) => {

    const response = await api.get(`users/managers/${id}`, {
        params: {
            page
        }
    });

    return response;

}
// função para pesquisar dados do gerente

// função para adicionar centro de custo ao gerente
const UsersMangersAddCostCenterService = async (user: number, cost_center: number) => {

    const response = await api.get(`users/managers/${user}/${cost_center}`);

    return response;

}
// função para adicionar centro de custo ao gerente

// função para ativar desativar/acesso a um centro de custo
const UsersManagersDeleteCostCenterService = async (id: number) => {

    const response = await api.delete(`users/managers/cost_centers/${id}`);

    return response;

}
// função para ativar desativar/acesso a um centro de custo

export {
    UsersService,
    ApproversService,
    RolesService,
    CreateUserService,
    UserShowService,
    UserUpdateService,
    UserChangePasswordService,
    UserDeleteService,
    UsersManagersService,
    UsersManagersShowService,
    UsersMangersAddCostCenterService,
    UsersManagersDeleteCostCenterService
}